export const MASTER_KEY = String(process.env.MASTER_KEY)
export const API_URL = String(process.env.API_URL)
export const WS_API_URL = String(API_URL.replace('https://', ''))
export const BUILD_TYPE = String(process.env.BUILD_TYPE)
export const USE_TRANSLATIONS = true
